import { render, staticRenderFns } from "./ApiKeysCollapse.vue?vue&type=template&id=45cd8f29&"
import script from "./ApiKeysCollapse.vue?vue&type=script&lang=js&"
export * from "./ApiKeysCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports